import { Helmet } from "react-helmet"

export const Head = () => {
  return (
    <Helmet>
        <title>Contact Us</title>
        <meta name="description" content="35E north road, Georgetown Guyana Nigeria Representative office at Plot 1271, Suite 29 (3rd Floor) Bataiya Plaza, 5, Rahama Close, off Dunukofia Street, off Ahmadu Bello Way, Area 11, Garki, Abuja" />
    </Helmet>
  )
}
